<template>
  <div class="container">
    <div style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
      <i class="el-icon-s-fold" ></i>
      <el-breadcrumb separator="/" >
        <el-breadcrumb-item >内容管理</el-breadcrumb-item>
        <el-breadcrumb-item >识别码管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
      <div class="tabs-content">
          <div class="condition">
            <div style="">
              <el-tabs
              type="border-card"
              style="background-color: transparent;border: 1px solid #1A3F81;border-radius: 12px;"
              v-model="activeName"
              @tab-click="handleClick"
              >
                <el-tab-pane name="equipcode">
                  <span slot="label"><i class="el-icon-date"></i> 设备识别规则</span>
                  <div class="list-used">
                      <div class="header-common">
                        <div class="header-common-left">
                          <div class="title">设备识别规则列表</div>
                        </div>
                        <header class="header-common-right">
                          <el-button
                            class="right-button-export"
                            @click="exportTable(1)"
                            type="text"
                            >
                            导出
                          </el-button>
                          <router-link v-if="showActionAdd==true" class="right-button-base" :to="{path:'/manage/rules/rules-add-equip'}">
                            新增设备识别规则
                          </router-link>
                        </header>
                      </div>
                      <div >
                        <el-table
                          style="width: 100%;"
                          border
                          default-expand-all
                          v-loading='loading'
                          :cell-style="tableCellStyle"
                          :header-cell-style="tableHeaderCellStyle"
                          :max-height="tableHeight"
                          :data="tableData.filter(data => !search1 || data.typeCode.toLowerCase().includes(search1.toLowerCase()) || data.typeName.toLowerCase().includes(search1.toLowerCase()))"
                          >

                            <el-table-column
                              type="index"
                              label="序号">
                            </el-table-column>
                            <el-table-column
                              prop="typeCode"
                              label="识别代码">
                            </el-table-column>
                            <el-table-column
                              prop="typeName"
                              label="产品名称">
                            </el-table-column>
                            <el-table-column
                              prop="typeModel"
                              label="规格型号">
                            </el-table-column>

                            <!-- <el-table-column
                              prop="typeName"
                              label="对应类型">
                            </el-table-column> -->
                            <el-table-column
                              v-if="showActionDelete==true"
                              label="操作"
                              width="230">
                              <template slot="header" slot-scope="scope">
                                <el-input
                                  id="search1"
                                  v-model="search1"
                                  size="mini"
                                  placeholder="输入关键字搜索"/>
                              </template>
                              <template slot-scope="scope">
                                <el-button
                                  @click.native.prevent="deleteRow(scope.$index, scope.row)"
                                  type="text"
                                  size="small"
                                  style="background-color: #20478D;"
                                  class="action-button">
                                  删除
                                </el-button>
                              </template>
                            </el-table-column>
                        </el-table>
                      </div>
                  </div>
                </el-tab-pane>
                  <el-tab-pane style="background-color: transparent;" name="conscode">
                    <span slot="label"><i class="el-icon-date"></i> 耗材识别规则</span>
                    <div class="list-used">
                        <div class="header-common">
                          <div class="header-common-left">
                            <div class="title">耗材识别规则列表</div>
                          </div>
                          <header class="header-common-right">
                            <el-button
                              class="right-button-export"
                              @click="exportTable(2)"
                              type="text"
                              >
                              导出
                            </el-button>
                            <router-link v-if="showActionAdd==true" class="right-button-base" :to="{path:'/manage/rules/rules-add-cons'}">
                              新增耗材识别规则
                            </router-link>
                          </header>
                        </div>
                        <div >
                          <el-table
                          v-loading='loading'
                            style="width: 100%;"
                            row-key="id"
                            border
                            default-expand-all
                            border
                            :cell-style="tableCellStyle"
                            :header-cell-style="tableHeaderCellStyle"
                            :max-height="tableHeight"
                            :data="consTableData.filter(data => !search2 || data.typeCode.toLowerCase().includes(search2.toLowerCase()) || data.typeName.toLowerCase().includes(search2.toLowerCase()))"

                            >

                              <el-table-column
                                type="index"
                                label="序号">
                              </el-table-column>
                              <el-table-column
                                prop="typeCode"
                                label="识别代码">
                              </el-table-column>
                              <el-table-column
                                prop="typeName"
                                label="产品名称">
                              </el-table-column>
                              <el-table-column
                                prop="typeModel"
                                label="规格型号">
                              </el-table-column>
                              <el-table-column
                                label="操作"
                                width="230">
                                <template slot="header" slot-scope="scope">
                                  <el-input
                                  id="search2"
                                    v-model="search2"
                                    size="mini"
                                    placeholder="输入关键字搜索"/>
                                </template>
                                <template slot-scope="scope">
                                  <el-button
                                    v-if="showActionDelete==true"
                                    @click.native.prevent="deleteConsRow(scope.$index, scope.row)"
                                    type="text"
                                    size="small"
                                    style="background-color: #20478D;"
                                    class="action-button">
                                    删除
                                  </el-button>
                                </template>
                              </el-table-column>
                          </el-table>
                        </div>
                    </div>
                  </el-tab-pane>
              </el-tabs>
            </div>
          </div>
      </div>
  </div>

</template>

<script>
  import {dataConversionUtil} from '../../../utils/excel.js'
  import { permissionCheckUtil } from '../../../utils/permission.js'

  export default {
    data() {
      return{
        contentStyle:{
          'border':'1px solid #1A3F81',
          'color' : '#fff',
          'font-size': '15px',
          'font-weight': 'solid',
          'border-bottom':'0px solid #1A3F81',
          'border-right':'0px solid #1A3F81'
        },
        labelStyle:{
          'width': '108px',
          'height': '20px',
          'font-size': '14px',
          'font-weight': 'bold',
          'color': '#00FFFF',
          'background-color':'transparent',
          'border':'1px solid #1A3F81',
          'border-bottom':'0px solid #1A3F81',
        },

        search1:'',
        search2:'',
        //耗材使用记录
        tableData:[],
        consTableData:[],
        loading:false,

        activeName:'equipcode',
        showActionAdd:false,
        showActionDelete:false,
        tableHeight:0,
      }
    },
    methods: {
      tableCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);text-align:center;font-size: 14px;font-weight: 400;color: #FEFEFE;text-align:left;'
      },
      tableHeaderCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);background:#021950;text-align:left;font-size: 15px;font-weight: 400;color: #00FFFF;'
      },
      handleClick(tab, event){
        this.search1 = ''
        this.search2 = ''

        if (tab.name == 'equipcode') {
          this.getEquipRules()
        } else if (tab.name == 'conscode'){
          this.getConsRules()
        }
      },
      getEquipRules(){
        this.loading = true;
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/equipment/type/list';

        this.$http({
          method:'GET',
          url:url,
          headers:headers
        }).then(res=>{
          this.loading = false;
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.types){
                // 获取设备数据
                this.tableData = obj.data.types;
              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          this.loading = false;
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      getConsRules(){
        this.loading = true;
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/consumable/type/list';

        this.$http({
          method:'GET',
          url:url,
          headers:headers
        }).then(res=>{
          this.loading = false;
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.types){
                // 获取设备数据
                this.consTableData = obj.data.types;
              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          this.loading = false;
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      // 排序
      // handleSortChange({ column, prop, order }) {
      //     const sortingColumn = column.property;
      //     const sortingOrder = column.order;

      //     // 根据排序要求对tableData进行排序
      //     this.tableData.sort((a, b) => {
      //       if (sortingOrder === 'ascending') {
      //         return a[sortingColumn] > b[sortingColumn] ? 1 : -1;
      //       } else if (sortingOrder === 'descending') {
      //         return a[sortingColumn] < b[sortingColumn] ? 1 : -1;
      //       } else {
      //         return 0;
      //       }
      //     });
      //   },
      deleteRow(index,row) {
        this.$confirm('此操作将永久删除该识别规则，是否继续？','提示',{
          confirmButtonText:'确定',
          cancelButtonText:'取消',
          type:'warning'
        }).then(() => {
          this.deleteRowAction(index,row.typeCode);
        }).catch(() => {
          this.$message({
            type:'info',
            message:'取消删除'
          })
        })
      },
      deleteRowAction(index,id){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/equipment/type/delete';
        const data = {"code":id}

        this.$http({
          method:'POST',
          url:url,
          headers:headers,
          data:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              // 注销成功
              this.tableData.splice(index,1);
              this.$message({
                type:'success',
                message:'已删除'
              })
            }else{
              this.$message.error(obj.message)
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      deleteConsRow(index,row) {
        this.$confirm('此操作将永久删除该耗材类型识别规则，是否继续？','提示',{
          confirmButtonText:'确定',
          cancelButtonText:'取消',
          type:'warning'
        }).then(() => {
          this.deleteConsRowAction(index,row.typeCode);
        }).catch(() => {
          this.$message({
            type:'info',
            message:'取消删除'
          })
        })
      },
      deleteConsRowAction(index,id){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/consumable/type/delete';
        const data = {"code":id}

        this.$http({
          method:'POST',
          url:url,
          headers:headers,
          data:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              // 注销成功
              this.tableData.splice(index,1);
              this.$message({
                type:'success',
                message:'已删除'
              })
            }else{
              this.$message.error(obj.message)
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }

        })
      },
      exportTable(type){
        var tableHeader = [['序号','识别代码','对应类型']];
        var dataList = [];
        var documentName = ''
        var array = []

        switch(type){
          case 1:{
            documentName = '设备识别规则列表';
            array = this.tableData;
          }
          break;
          case 2:{
            documentName = '耗材识别规则列表'
            array = this.consTableData;
          }
          break;
          default:this.$message('导出错误')
          break;
        }

        array.forEach((item,index)=>{
          dataList.push([
            index+1,
            item.typeCode,
            item.typeName
          ]);
        });

        if(dataList.length > 0){
          dataConversionUtil.dataToExcel(documentName,tableHeader,dataList)
          this.$message.success('导出成功')
        }else{
          this.$message.warning('无数据导出')
        }
        
      },
      judgePermissions(){
          let code1 = permissionCheckUtil.findName("typecode:create");
          let code2 = permissionCheckUtil.findName("typecode:delete");

          if(code1==true){
            this.showActionAdd = true;
          }
          if(code2==true){
            this.showActionDelete = true;
          }
      },
      sizeFun(){
        this.$nextTick(() => {
          this.tableHeight = window.innerHeight-285 < 300 ? 300 : window.innerHeight-285;
        })
      }
    },
    created() {
      this.judgePermissions()


    },
    beforeDestroy() {
      window.removeEventListener('resize',this.sizeFun)
    },
    mounted() {
      window.addEventListener('resize',this.sizeFun)
      this.sizeFun()
      this.getEquipRules()
    }
  }
</script>


<style lang="scss" scoped>
.container{
  margin-top: $header-height;

  .equipment-distribution{
    margin: 0px 0px 20px 7px;
    display: flex;
    flex-direction: row;

    .handle-distribution{
      width: 100%;
      min-width: 740px;
      height: 310px;
      // border: 2px #1A3F81 solid;
      border-radius: 18px;
      padding-right: 20px;
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      align-items: center;

      .handle-one{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        .line-left{
          margin-right: 10px;
          display: flex;
          flex-direction: row;
          align-items: center;

          p{
            color: #11FFF1;
            opacity: 0.2;
            font-size: 18;
            font-weight: 400;
          }

          span{
            color: #11FFF1;
            font-size: 18px;
            font-weight: 400;
          }
        }

        .line-middle{
          width: 162px;
          height: 162px;
          border-radius: 18px;
          // border: 2px solid rgba(0, 177, 183, 0.84);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .line-middle-rate{
            font-size: 25px;
            font-family: Helvetica;
            font-weight: bold;
            color: #00DEFF;
            // text-shadow: 0px 10px 10px rgba(1,24,33,0.7);

            background: linear-gradient(0deg, #FF1800 0.1953125%, #D3CC15 99.6337890625%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin-bottom: 0;

            span{
              font-size: 56px;
              font-weight: bold;
              background: linear-gradient(180deg, #D3CC15 0%, #FF1800 100%);

              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }

          .line-middle-rate-processing{
            font-size: 25px;
            font-family: Helvetica;
            font-weight: bold;
            color: #00DEFF;
            // text-shadow: 0px 10px 10px rgba(1,24,33,0.7);
            background: linear-gradient(0deg, #8033F2 0%, #00CCFF 99.6337890625%);            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin-bottom: 0;

            span{
              font-size: 56px;
              font-weight: bold;
              background: linear-gradient(0deg, #8033F2 0%, #00CCFF 99.6337890625%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }

          .line-middle-rate-finish{
            font-size: 25px;
            font-family: Helvetica;
            font-weight: bold;
            color: #00DEFF;
            // text-shadow: 0px 10px 10px rgba(1,24,33,0.7);
            background: linear-gradient(0deg, #00FF54 0.1953125%, #15D3CC 99.6337890625%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin-bottom: 0;

            span{
              font-size: 56px;
              font-weight: bold;
              background: linear-gradient(0deg, #00FF54 0.1953125%, #15D3CC 99.6337890625%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }



          .line-middle-status{
            font-size: 22px;

            font-weight: bold;
            color: #fff;
            text-shadow: 0px 10px 10px rgba(1,24,33,0.7);
            background: linear-gradient(180deg, #FFFFFF 0%, #47D6FF 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin: 0;
          }
        }

        .line-right{
          margin-left: 10px;
          display: flex;
          flex-direction: row;
          align-items: center;

          p{
            color: #11FFF1;
            opacity: 0.2;
            font-size: 18;
            font-weight: 400;
          }

          span{
            color: #11FFF1;
            font-size: 18px;
            font-weight: 400;
          }
        }
      }
    }

    .distribution-list{
      margin-top: 0;
      margin: 0px 0px 0px 6px;
      padding-bottom: 10px;
    }
  }

  .tabs-content{

      .action-button{
        width: 89px;
        height: 31px;
        background: #FAFAFA;
        border: 1px solid rgba(0,144,255,0.84);
        border-radius: 20px;
        background-color: #20478D;
        font-size: 14px;
        font-weight: 400;
        color: #00DEFF;
        // margin-right: 20px;
      }

    .table-content{

      .table-list{

      }
    }

  }

  // 公共头部样式

  .header-common{
    width: 100%;
    height: 45px;
    border-radius: 12px 12px 0 0 ;
    background: linear-gradient(-90deg, #001940, #1564BE);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-right: 26px;

    .header-common-left{
      font-size: 20px;
      font-weight: bold;
      color: #FEFEFE;
      margin-left: 21px;
      .title{
        font-size: 20px;
        font-weight: bold;
        color: #FEFEFE;
      }
    }
    .header-common-right{

      .right-button{
        width: 149px;
        height: 40px;
        background: #FAFAFA;
        border: 1px solid rgba(0,255,96,0.84);
        border-radius: 20px;
        background-color: #208D7F;
        font-size: 14px;
        font-weight: 400;
        color: #00FFB4;
        margin-right: 20px;
      }

      .right-button-export{
        font-size: 14px;
        font-weight: 400;
        color: #00FFB4;
        margin-right: 20px;
      }

      .right-button-base{
        width: 149px;
        height: 40px;
        border: 1px solid rgba(0,144,255,0.84);
        border-radius: 20px;
        background-color: #20478D;
        font-size: 14px;
        font-weight: 400;
        color: #00DEFF;
        margin-right: 20px;
        display: inline-block;
        text-align: center;
        text-decoration: none;
        line-height: 40px;
      }
    }

  }

}

</style>



// WEBPACK FOOTER //
// src/view/manage/rules/rules-list.vue